import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  margin: 32px 0 24px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
    color: ${tokens.ColorGrey800};
    margin: 24px 0 0;
  }
`;

class ContributionPerPaycheckModal extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Contribution per Paycheck'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            Limits may restrict the amount you can contribute. If your total contributions across all accounts is
            greater than your annual salary, our projections will limit your modeled contributions to your salary.
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default ContributionPerPaycheckModal;
